<script setup lang="ts">
import { computed } from 'vue';
import { CompromissoForm } from '~/lib/fw';
import { useAuthenticationStore } from '~/stores/authenticationStore';

interface Props {
  pastaCodigos?: string[];
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();

const emit = defineEmits(['close']);

const authenticationStore = useAuthenticationStore();
const buttonsDisabled = computed(() => {
  if (!props.compromisso) {
    return false;
  }
  return authenticationStore.user!.id !== props.compromisso.responsavelCodigo;
});
</script>

<template>
  <CompromissoForm
    action="planilha-atualizacao-debito/confirmar-envio-planilha-atualizacao-debito-ao-banco"
    :pasta-codigos="props.pastaCodigos ?? []"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :show-upload-files="true"
    :submit-button-disabled="buttonsDisabled"
    :devolver-button-visible="true"
    :devolver-button-disabled="buttonsDisabled"
    @close="() => emit('close')"
  >
    <template #form>
      <a-alert
        message="Confirme o compromisso caso tenha enviado a planilha ao banco"
        show-icon
      />
    </template>
  </CompromissoForm>
</template>
